import { render, staticRenderFns } from "./MunicipioIss.vue?vue&type=template&id=62aa3536"
import script from "./MunicipioIss.vue?vue&type=script&lang=js"
export * from "./MunicipioIss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports